import { useTheme } from '@mui/material';
import { PartnerName } from 'configs/constants';
import { getPartnerName } from 'partners';
import { CSSProperties } from 'react';

/**
 * The newaieye partner ships white logo SVGs. On the light theme they vanish
 * against the light background, so we invert them to black with a CSS filter.
 *
 * Returns an empty style for every other partner and for the dark theme, so no
 * other partner/img/theme is impacted. Spread the result onto the logo <img>'s
 * style.
 */
export const useLogoContrastStyle = (): CSSProperties => {
  const theme = useTheme();

  return getPartnerName() === PartnerName.NEWAIEYE &&
    theme.palette.mode === 'light'
    ? { filter: 'brightness(0)' }
    : {};
};
